import { useState } from 'react';
import styled from 'styled-components';

import Button from 'components/modules/button/Button';
import Modal from 'components/modules/modal/Modal';
import { ArrivalTimeItems } from 'constant';
import { toast } from 'react-toastify';

interface ModalDeleteProps {
  onClose: (option: any) => void;
}

const ModalDuration = ({ onClose }: ModalDeleteProps) => {
  const [isShow, setShow] = useState(true);
  const [selectedOption, setSelectedOption] = useState<any>(undefined);

  const toastMessage = (message: string) => <div style={{ fontSize: '1.1rem' }}>{message}</div>;

  const _Close = () => {
    if (selectedOption === undefined) return toast(toastMessage('시간을 선택해주세요'), { type: 'error' });
    setShow(false);
    onClose(selectedOption);
  };

  const onSelectMessage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };

  return (
    <Modal isOpen={isShow} onClose={_Close}>
      <ModalOptionTemplate>
        <HeaderTemplate>
          <HeaderText>{'도착예정시간 선택해 주세요'}</HeaderText>
        </HeaderTemplate>
        <ScrollWrap>
          {ArrivalTimeItems.map((item, index) => (
            <FormTr key={index}>
              <FormDataTd>
                <RadioInput
                  id={item.name}
                  onChange={onSelectMessage}
                  value={item.value}
                  type="radio"
                  name={'message'}
                />
                <RadioLabel htmlFor={item.name}>{item.name}</RadioLabel>
              </FormDataTd>
            </FormTr>
          ))}
        </ScrollWrap>
        <FooterWrap>
          <Button title="확인" color="confirm" onClick={() => _Close()} />
        </FooterWrap>
      </ModalOptionTemplate>
    </Modal>
  );
};

const ModalOptionTemplate = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -40%);
  width: 300px;
  max-height: 460px;
  flex-flow: column nowrap;
  background-color: #ffffff;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
`;
const HeaderTemplate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  padding: 0 20px;
`;
const HeaderText = styled.div`
  font-size: 19px;
  font-weight: 600;
  line-height: 30px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-line;
`;
const ScrollWrap = styled.ul`
  display: flex;
  max-height: 300px;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scrollbar-width: none;
  margin: 0 20px;
  gap: 10px;
`;
const FooterWrap = styled.div`
  padding: 20px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
    border-radius: 10px;
    min-height: 40px;
    max-width: 140px;
    cursor: pointer;
  }
`;
const FormTr = styled.li`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const FormDataTd = styled.div`
  display: flex;
  justify-content: center;
`;
const RadioInput = styled.input``;

const RadioLabel = styled.label`
  display: inline-block;
  padding: 5px 10px;
  margin-left: 5px;
  border-radius: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #000000;
  white-space: pre-wrap;
  width: 100%;
`;

export default ModalDuration;
